import styled from 'styled-components';
import {
  whiteSphera,
  neutralBlue,
  neutralBlueGray,
  neutralLight,
  greenSp,
  brandBlack
} from 'src/utilities/UIStyles/variables/Colors';

export const ProfessionalInfoContainer = styled.div`
  width: 90%;
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  padding: 2.5%;
  justify-content: space-between;
  background-color: ${whiteSphera};
  border-radius: 5px;
  -webkit-box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.1);
  box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.1);

  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
  }
`;

export const ProfesionalSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 3% 2.5%;
  width: 100%;
  > h3 {
    color: ${greenSp};
    font-size: 1.5vw;
    text-align: center;
    width: 100%;
  }
  > div {
    width: 80%;
    margin: 3% 20%;
    display: flex;
    justify-content: space-evenly;
    > button {
    }
    > p {
      color: ${neutralBlueGray};
      font-size: 1.3vw;
      padding: 1% 0;
      background-color: ${neutralLight};
    }
    > input {
      border-radius: 5px;
      border-style: none;
      width: 80%;
      padding: 1% 0;
      border: 1px solid ${neutralBlue};
    }
  }
`;

export const Contracts = styled.div`
  width: 90%;
  margin: 0 auto;
  padding: 2.5%;
  background-color: ${whiteSphera};
  border-radius: 5px;
  -webkit-box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.1);
  box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.1);

  > div {
    display: flex;
    margin-bottom: 2.5%;

    > div {
      width: 33%;

      > p {
        color: ${brandBlack};
        font-size: 1.5vw;
        width: 100%;
      }
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
  }
`;

export const ContractNull = styled.div`
  width: 100%;
  margin: 2%;
  text-align: center;
  > h1 {
    width: 100%;
    font-size: 1.6vw;
    color: ${greenSp};
  }
`;
